import { vi } from 'vitest';
import type { Fn, PickByFnKeys } from '../types';

export async function buildPartialMock<T>(
  original: () => Promise<T>,
  ...mockKeys: PickByFnKeys<T>[]
) {
  const fs = await original();

  const entries = mockKeys.map(key => {
    const orignalFn = fs[key] as Fn;
    const mocked = vi.fn().mockImplementation(orignalFn);

    return [key, mocked];
  });

  const rest = Object.fromEntries(entries);

  const out: T = {
    ...fs,
    ...rest,
  };

  return out;
}
